<ion-col size="12" sizeXl="6">
  <ion-row *ngIf="_chartTypes.Maaned.active" class="row-m">
    <ion-col>
      <ion-row>
        <ion-col>
          <h2 class="monthTitleText">Sammenlign forbruk</h2>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="availableYearsForbruk">
        <ion-col size="6" offset="3" class="monthButtonCol">
          <ion-button
            *ngFor="let year of availableYearsForbruk"
            class="hundred"
            [class.selected]="selectedYearsForbrukMonth.includes(year)"
            (click)="setSelectedYearsForbrukMonth(year)"
          >
            {{ year }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row class="row-m">
    <ion-col>
      <app-forbruk-chart
        [hasFetchingError]="hasFetchingError"
        [valgtAarAnlegg]="valgtAarAnlegg"
        [minDate]="minDate"
        [valgtMaanedAnlegg]="valgtMaanedAnlegg"
        [selectedYearsForbrukMonth]="selectedYearsForbrukMonth"
        [valgtDagAnlegg]="valgtDagAnlegg"
        [selectedDateDay]="selectedDateDay"
        [valgtTimeAnlegg]="valgtTimeAnlegg"
        [selectedDateHour]="selectedDateHour"
      ></app-forbruk-chart>
      <!-- TALL UNDER GRAF -->
      <app-forbrukstall
        *ngIf="_chartTypes.Dag.active || _chartTypes.Time.active"
        [selectedDateDay]="selectedDateDay"
        [selectedDateHour]="selectedDateHour"
        [valgtDagAnlegg]="valgtDagAnlegg"
        [valgtTimeAnlegg]="valgtTimeAnlegg"
      ></app-forbrukstall>
    </ion-col>
  </ion-row>
</ion-col>
